/* add global writables here */

import {derived, readable, writable} from 'svelte/store';

export const eventBridge = readable(window.eventBridge);

export const resourcesPath = readable(window.resourcesPath || '');

export const currentPage = writable(null);

export const loginToken = writable(null);

export const loginPin = writable('');

export const beaConfiguration = writable({});

export const loginTokens = writable([]);

export const loginLastTokens = writable([]);

export const loginLastToken = writable(null);

export const csAvailable = derived(eventBridge, ($eventBridge, set) => {
    const unavailable = () => set(false);
    const available = () => set(true);
    $eventBridge?.addEventListener('cs:noClientSecurity', unavailable);
    $eventBridge?.addEventListener('cs:VersionRead', available);

    return () => {
        $eventBridge?.removeEventListener('cs:noClientSecurity', unavailable);
        $eventBridge?.removeEventListener('cs:VersionRead', available);
    };
}, false);

export const csSupported = derived(eventBridge, ($eventBridge, set) => {
    const unknown = () => set(undefined);
    const supported = () => set(true);
    $eventBridge?.addEventListener('cs:noClientSecurity', unknown);
    $eventBridge?.addEventListener('kc:supportedCsVersion', supported);

    return () => {
        $eventBridge?.removeEventListener('cs:noClientSecurity', unknown);
        $eventBridge?.removeEventListener('kc:supportedCsVersion', supported);
    };
}, undefined);

export const csAvailableSupported = derived(
    [csAvailable, csSupported],
    ([$csAvailable, $csSupported]) => $csAvailable && $csSupported,
    false
);

export const portalConfiguration = derived(eventBridge, ($eventBridge, set) => {
    function handleConfigEvent(event) {
        if (event.detail?.configuration) {
            set(event.detail.configuration);
        }
    }

    $eventBridge?.addEventListener('portal:config', handleConfigEvent);
    $eventBridge?.dispatchEvent('portal:requestConfig');

    return () => {
        $eventBridge?.removeEventListener('portal:config', handleConfigEvent);
    };
}, {});
